export default __webpack_public_path__ + "static/FoundersGrotesk-Medium-8c4ff0dd1c3658e6ab4714f63389d77a.ttf";